/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOrder = exports.PlatformEnum = exports.EventType = exports.AgentOfferStatusEnum = void 0;
var AgentOfferStatusEnum;
(function (AgentOfferStatusEnum) {
    AgentOfferStatusEnum["NOT_STARTED"] = "NOT_STARTED";
    AgentOfferStatusEnum["SUGGESTED"] = "SUGGESTED";
    AgentOfferStatusEnum["REJECTED"] = "REJECTED";
    AgentOfferStatusEnum["REQUESTED"] = "REQUESTED";
    AgentOfferStatusEnum["ALREADY_COMPLETED"] = "ALREADY_COMPLETED";
    AgentOfferStatusEnum["NOT_RELEVANT"] = "NOT_RELEVANT";
    AgentOfferStatusEnum["PAUSED"] = "PAUSED";
})(AgentOfferStatusEnum = exports.AgentOfferStatusEnum || (exports.AgentOfferStatusEnum = {}));
var EventType;
(function (EventType) {
    EventType["UNKNOWN"] = "UNKNOWN";
    EventType["VIEW"] = "VIEW";
    EventType["MAIN_CTA_CLICK"] = "MAIN_CTA_CLICK";
    EventType["SECONDARY_CTA_CLICK"] = "SECONDARY_CTA_CLICK";
    EventType["AGENT_MARK"] = "AGENT_MARK";
    EventType["SKIP"] = "SKIP";
    EventType["UNSKIP"] = "UNSKIP";
    EventType["CLOSE"] = "CLOSE";
    EventType["SHOW_LATER"] = "SHOW_LATER";
})(EventType = exports.EventType || (exports.EventType = {}));
var PlatformEnum;
(function (PlatformEnum) {
    PlatformEnum["UNKNOWN"] = "UNKNOWN";
    PlatformEnum["BUSINESS_MANAGER"] = "BUSINESS_MANAGER";
    PlatformEnum["EDITORX"] = "EDITORX";
    PlatformEnum["EDITOR"] = "EDITOR";
    PlatformEnum["ADI"] = "ADI";
    PlatformEnum["OWNER_APP"] = "OWNER_APP";
    PlatformEnum["BRANDED_APP"] = "BRANDED_APP";
})(PlatformEnum = exports.PlatformEnum || (exports.PlatformEnum = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
//# sourceMappingURL=types.js.map